import React, { useEffect, useRef, useState } from 'react'
import { Button, Modal } from 'antd'
import { useSelector, useDispatch } from 'react-redux'
import IntlMessages from '../../util/IntlMessages'
import {
  closingNumPad,
  formatDigits,
  isEmptyObject,
  loadFormDiscCurr,
  loadFormDiscPer,
  loadNumChange,
  loadNumPadType,
  loadNumRelateData,
  loadShowNumPad
} from '../../appRedux/actions'
import {
  ArrowLeftOutlined,
  CloseCircleOutlined,
  CloseOutlined
} from '@ant-design/icons'
import { NumPadTypes } from '../../constants/MobAppConstants'

const NumPad = props => {
  const { callback, setFormCalVal, from } = props
  const dispatch = useDispatch()
  // const numpadRef = useRef(null)

  const showNumPadForDiscount = useSelector(
    ({ Sell }) => Sell.showNumPadForDiscount
  )
  const showNumPadForPayment = useSelector(
    ({ Sell }) => Sell.showNumPadForPayment
  )
  const getIsRefundSale = useSelector(
    ({ MainSale }) => MainSale.getIsRefundSale
  )
  const showNumPad = useSelector(({ Sell }) => Sell.showNumPad)
  const numPadType = useSelector(({ Sell }) => Sell.numPadType)
  const numPadData = useSelector(({ Sell }) => Sell.numPadData)
  const numDataChange = useSelector(({ Sell }) => Sell.numDataChange)

  const [display, setDisplay] = useState('0.00')

  // useEffect(() => {
  //   let mounted = true
  //   const aaa = from
  //   if (mounted && showNumPad) {
  //     // if (numPadType && numPadType == NumPadTypes.AMOUNT_TO_PAY) {
  //     //   setDisplay(formatDigits(numPadData, getDefaultDecimalPlaces))
  //     // }
  //   }

  //   return () => {
  //     mounted = false
  //   }
  // }, [showNumPad])

  function handleClick (number) {
    // NOTE: 1 for quantiy, 2 for price & 3 for discount
    if (number && number == 'back') {
      setDisplay(
        !display || display.length == 1
          ? '0.00'
          : display == '0.00'
          ? display
          : display.slice(0, -1)
      )
    } else if (number && number == 'enter') {
      if (numPadType && numPadType == NumPadTypes.QUANTITY) {
        dispatch(loadNumChange(parseInt(display)))
      } else if (numPadType && numPadType == NumPadTypes.PRICE) {
        dispatch(
          loadNumChange(parseFloat(display) == 0 ? 'zero' : parseFloat(display))
        )
      } else if (numPadType && numPadType == NumPadTypes.DISCOUNT) {
        dispatch(
          loadNumChange(parseFloat(display) == 0 ? 'zero' : parseFloat(display))
        )
      } else if (numPadType && numPadType == NumPadTypes.AMOUNT_TO_PAY) {
        callback(parseFloat(display))
      } else if (numPadType && numPadType == NumPadTypes.WHOLE_DISCOUNT) {
        closingNumPad(dispatch)
        // if (numPadData && numPadData.type) {
        //   if (numPadData.type == 'percent') {
        //     dispatch(loadFormDiscPer(parseFloat(display)))
        //   } else if (numPadData.type == 'currency') {
        //     dispatch(loadFormDiscCurr(parseFloat(display)))
        //   }
        // }
      }
    } else if (number && number == 'close') {
      closingNumPad(dispatch)
    } else if (number && number == 'clear') {
      setDisplay('0.00')
    } else if (number && number == '-') {
      if (display && display.includes('-') && getIsRefundSale) {
      } else {
        const ad = display != '0.00' ? display : ''
        setDisplay('-' + ad)
      }
    } else {
      const nbr = display == '0.00' ? `${number}` : validateNum(display, number)
      setDisplay(nbr)
      if (numPadType && numPadType == NumPadTypes.WHOLE_DISCOUNT) {
        if (numPadData && numPadData.type) {
          if (numPadData.type == 'percent') {
            setFormCalVal(parseFloat(nbr))
            // dispatch(loadFormDiscPer(parseFloat(nbr)))
          } else if (numPadData.type == 'currency') {
            setFormCalVal(parseFloat(nbr))
            // dispatch(loadFormDiscCurr(parseFloat(nbr)))
          }
        }
      }
    }
  }

  function validateNum (display, number) {
    let result = '0.00'
    const check = parseFloat(display + `${number}`)
    if (check == 0 || check) {
      const put = `${display}${number}`
      const dotMatches = put.match(/\./g)
      result = dotMatches != null && dotMatches.length == 2 ? '0.00' : put
    }
    return result
  }

  // const handleOutsideClick = event => {
  //   if (numpadRef.current && !numpadRef.current.contains(event.target)) {
  //     // Clicked outside the numpad component
  //     // dispatch(loadShowNumPad(false))
  //   }
  // }

  return (
    <Modal
      className='calculator-modal'
      title={
        <div className='calc-head'>
          {numPadType && numPadType != 0 && (
            <span className='ch-1'>
              {numPadType == NumPadTypes.QUANTITY
                ? `Quantity For :`
                : numPadType == NumPadTypes.PRICE
                ? `Price For :`
                : numPadType == NumPadTypes.DISCOUNT
                ? `Discount For :`
                : numPadType == NumPadTypes.CUSTOMER
                ? `For Customer :`
                : numPadType == NumPadTypes.AMOUNT_TO_PAY
                ? `Amount To Pay:`
                : numPadType == NumPadTypes.WHOLE_DISCOUNT
                ? `Discount Apply on Sale`
                : ''}
            </span>
          )}
          {numPadType &&
            (numPadType == NumPadTypes.QUANTITY ||
              numPadType == NumPadTypes.PRICE ||
              numPadType == NumPadTypes.DISCOUNT) &&
            !isEmptyObject(numPadData) && (
              <span className='ch-2'> {numPadData.productName}</span>
            )}
        </div>
      }
      visible={showNumPad || showNumPadForDiscount || showNumPadForPayment}
      closeIcon={
        <Button
          className='close-icon-titu dk-btn-cancel'
          icon={<CloseOutlined />}
          onClick={() => {
            closingNumPad(dispatch)
          }}
        />
      }
      // onCancel={() => {
      //   closingNumPad(dispatch)
      // }}
      // width={400}
      centered={true}
      footer={null}
      width='fit-content' // Set the width to fit the content
    >
      {/* <div className='dialog-container'> */}
      <div
        // ref={numpadRef}
        className='numpad'
      >
        <div className='head-titudiv'>
          <span>{display}</span>
        </div>
        <div className='numpad-row'>
          {numPadType && numPadType == NumPadTypes.QUANTITY && getIsRefundSale && (
            <Button
              style={{ backgroundColor: 'rgb(239 78 81)' }}
              className='titu-btn'
              onClick={() => handleClick('-')}
            >
              -
            </Button>
          )}
          <Button
            style={{ backgroundColor: 'rgb(239 78 81)' }}
            className='titu-btn'
            onClick={() => handleClick('clear')}
          >
            C
          </Button>
          {numPadType != NumPadTypes.QUANTITY && (
            <Button
              disabled={numPadType && numPadType == NumPadTypes.QUANTITY}
              className='titu-btn'
              onClick={() => handleClick('.')}
            >
              .
            </Button>
          )}
          <Button
            style={{ backgroundColor: '#1890ff' }}
            className='titu-btn'
            onClick={() => handleClick('back')}
          >
            <ArrowLeftOutlined />
          </Button>
        </div>
        <div className='numpad-row'>
          <Button className='titu-btn' onClick={() => handleClick(7)}>
            7
          </Button>
          <Button className='titu-btn' onClick={() => handleClick(8)}>
            8
          </Button>
          <Button className='titu-btn' onClick={() => handleClick(9)}>
            9
          </Button>
        </div>
        <div className='numpad-row'>
          <Button className='titu-btn' onClick={() => handleClick(4)}>
            4
          </Button>
          <Button className='titu-btn' onClick={() => handleClick(5)}>
            5
          </Button>
          <Button className='titu-btn' onClick={() => handleClick(6)}>
            6
          </Button>
        </div>
        <div className='numpad-row'>
          <Button className='titu-btn' onClick={() => handleClick(1)}>
            1
          </Button>
          <Button className='titu-btn' onClick={() => handleClick(2)}>
            2
          </Button>
          <Button className='titu-btn' onClick={() => handleClick(3)}>
            3
          </Button>
        </div>
        <div className='numpad-row'>
          <Button className='titu-btn' onClick={() => handleClick('00')}>
            00
          </Button>
          <Button className='titu-btn' onClick={() => handleClick(0)}>
            0
          </Button>
          <Button
            style={{ backgroundColor: '#41af4b' }}
            className='titu-btn'
            onClick={() => handleClick('enter')}
          >
            Done
          </Button>
        </div>
      </div>
      {/* </div> */}
    </Modal>
  )
}

export default NumPad
